import { UserFriendlyError } from "../../../../../common/utils/base_error";
import { ICreateColetaPrecoUseCase } from "../../../presentation/useCases/create/create_coleta_preco_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * CreateColetaPrecoUseCase
 */

export class CreateColetaPrecoUseCase implements ICreateColetaPrecoUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async createColetaPreco(
    status: number,
    dataCadastro: Date,
    idRequisicaoCompra: number | undefined,
    dataColeta: Date | undefined,
    idSubconta: number | undefined,
    idFuncionarioComprador: number | undefined,
    idFuncionarioAprovadores: number[] | undefined,
    arquivo1: File | undefined,
    arquivo2: File | undefined,
    arquivo3: File | undefined,
  ): Promise<number> {
    if (idRequisicaoCompra === undefined) throw new UserFriendlyError('O campo "Nº da Requisição" deve ser preenchido!');
    return await this.repository.createColetaPreco(
      status,
      dataCadastro,
      idRequisicaoCompra,
      dataColeta ?? null,
      idSubconta ?? null,
      idFuncionarioComprador ?? null,
      idFuncionarioAprovadores && idFuncionarioAprovadores.length > 0 ? idFuncionarioAprovadores : null,
      arquivo1 ?? null,
      arquivo2 ?? null,
      arquivo3 ?? null,
    );
  }
}
